
function OrderManagementService($rootScope, Restangular, RestangularV3, _breakpointsService) {
    this.$rootScope = $rootScope;
    this._api = Restangular.one('order');
    this._apiv3 = RestangularV3.one('order');
    this._deliveryWindowApi = Restangular.one('DeliveryWindows');
    this.breakpointsService = _breakpointsService;
    this.loadingOrders = null;
    this.loadedOpenOrderCountResponse = null;

    this.timeTable = [];

    this.switchAction = { id: 0, action: '' };
}

OrderManagementService.prototype.invalidate = function () {
    // Call this function before getOrders in order to freshly load
    // orders
    // invalidate loadedOpenOrderCountResponse when orders get invalidated
    this.loadingOrders = null;
    this.orders = null;
    this.loadedOpenOrderCountResponse = null;
};

OrderManagementService.prototype.setOrders = function (orders) {
    this.orders = orders;
    return orders;
};

OrderManagementService.prototype.getOrders = function () {
    if (this.loadingOrders) {
        // if we have already loaded orders, return the resolved promise.
        return this.loadingOrders;
    }

    this.loadingOrders = this._api.get().then(this.setOrders.bind(this));

    return this.loadingOrders;
};

OrderManagementService.prototype.updateSelectedAction = function (orderId, action) {
    // This function gets updated whenever an option is selected from
    // an order-status-card
    this.switchAction.id = orderId;
    this.switchAction.action = action;
};

OrderManagementService.prototype.updateSelectedPendingOrder = function (orderId) {
    // This function gets updated whenever the dropdown option is clicked on
    // an order-status-card
    this.selectedPendingOrderId = orderId;
};

OrderManagementService.prototype.getPastOrderDeliveryWindow = function (orderId, isDelivery) {
    return this._deliveryWindowApi.one('PastOrder').get({ OrderId: orderId, isDelivery }).then((response) => {
        this.timeTable = response;
    });
};

OrderManagementService.prototype.savePastOrderDeliveryWindow = function (orderId, deliveryWindowId, windowDate) {
    return this._deliveryWindowApi.post('ReservePastOrderWindow', { OrderId: orderId, DeliveryWindowId: deliveryWindowId, WindowDate: windowDate }).then((response) => {
        if (response.IsSuccessful) {
            this.updateSelectedAction(0, '');
            return response;
        }
        return response;
    });
};

OrderManagementService.prototype.cancelOrder = function (orderId) {
    return this._api.post('cancel', { OrderId: orderId }).then(() => {
        this.updateSelectedAction(0, '');
    });
};

OrderManagementService.prototype.changeOrder = function (orderId) {
    return this._api.post('amend', { OrderId: orderId, OrderDeviceFormat: this.breakpointsService.getDeviceDisplayFormatString() }).then(() => {
        this.updateSelectedAction(0, '');
    });
};

OrderManagementService.prototype.getTotalOrderCount = function () {
    if (this.loadedOpenOrderCountResponse) {
        // if we have already loaded open orders count, return the resolved promise.
        return this.loadedOpenOrderCountResponse;
    }
    this.loadedOpenOrderCountResponse = this._apiv3.one('openordercount').get();
    return this.loadedOpenOrderCountResponse;
};

OrderManagementService.prototype.saveOrderToList = function (orderId) {
    return this._apiv3.one(`${orderId}/save`).post().then((response) => {
        // We need to broadcast when this happens so the product save to list component updates the list
        this.$rootScope.$broadcast('savedLists:AddNewList');

        return response;
    });
};

module.exports = OrderManagementService;



// WEBPACK FOOTER //
// ./src/order/ordermanagement/ordermanagement.service.js